import * as React from 'react';

import type {FilterObject, EntityListType} from 'nutshell-core/types';

import {Button} from 'shells/button/button';
import {FilterButton} from 'shells/filter-button/filter-button';

import {EntityListEntityCount} from '../../entity-list/header/entity-list-entity-count';
import {EntityListSearchBox} from '../../entity-list/header/entity-list-search-box';

import styles from './email-marketing-list-controls.module.css';

type Props = {
    entityCount: number;
    fieldFilterFunction: (fieldName: string) => boolean;
    filters: FilterObject[];
    isRefreshingFilters: boolean;
    isFilterDrawerOpen: boolean;
    onToggleFilterDrawerShown: () => void;
    removeAllFilters: () => any;
    onParamChange: (arg1: any, arg2: boolean) => any;
    currentSearch: string | null | undefined;
    graduatedFilters?: React.ReactNode;
    getRef: (arg1?: HTMLElement | null | undefined) => void;
    hideSearch?: boolean;
    entityType: EntityListType;
};

export function EmailMarketingListControls(props: Props) {
    // @ts-expect-error
    const filterObjFilter = (filterObj) => props.fieldFilterFunction(Object.keys(filterObj)[0]);
    const activeFilters = props.filters.filter(filterObjFilter);

    // We want to consider the page `filtered`
    // if there are any filters *or* a search query
    const canClearFilters = activeFilters.length >= 1 || Boolean(props.currentSearch);

    return (
        <div ref={props.getRef} className={styles.container}>
            <div className={styles['top-row']}>
                <div className={styles['top-row-left-group']}>
                    <div className={styles['filter-button']}>
                        <FilterButton
                            isOpen={props.isFilterDrawerOpen}
                            onClick={props.onToggleFilterDrawerShown}
                            activeFilters={activeFilters}
                        />
                    </div>
                    {props.graduatedFilters ? (
                        <div className={styles['graduated-filters']}>{props.graduatedFilters}</div>
                    ) : undefined}
                    {!props.hideSearch ? (
                        <div className={styles.search}>
                            <EntityListSearchBox
                                entityType={props.entityType}
                                value={props.currentSearch}
                                onChange={(search) => {
                                    props.onParamChange({q: search}, true);
                                }}
                            />
                        </div>
                    ) : undefined}
                    <div className={styles.count}>
                        <EntityListEntityCount
                            entityType={props.entityType}
                            entityCount={props.entityCount}
                            activeFilters={activeFilters}
                            isRefreshingFilters={props.isRefreshingFilters}
                            currentSearch={props.currentSearch}
                        />
                    </div>
                    {canClearFilters ? (
                        <div className={styles['remove-filters']}>
                            <Button
                                size='small'
                                variant='text-primary'
                                onClick={props.removeAllFilters}
                            >
                                Remove filters
                            </Button>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
}
